/* eslint-disable no-new */
import { apiPostImage } from '@/modules/Damage/services/damages/'
import { mapState } from 'vuex'
import { WARRANTY_MODULE_NAME } from '@/store/types'
import maSpinner from '@/components/spinner'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import Compressor from 'compressorjs'

import * as Sentry from '@sentry/vue'

export default {
  name: 'FileImg',

  mixins: [flowMixin],

  components: {
    maSpinner
  },

  props: {
    name: {
      type: String
    },
    titleInput: {
      type: String
    },
    imageList: {
      type: Array
    }
  },

  data: function() {
    return {
      inputName: '',
      errorInput: false,
      spinner: null
    }
  },

  methods: {
    postImage(file) {
      this.spinner = true
      let imageContent
      const imageType = this.inputName
      const imageName = file.name
      const reader = new FileReader()
      const sinisterId = this.getSinisterId
      reader.readAsDataURL(file)
      reader.onload = async () => {
        const base64img = reader.result
        imageContent = base64img.replace(/data:[A-z]*\/[A-z]*;base64,/, '')
        let imgBody = {
          imageName: imageName,
          imageType: imageType,
          imageContent: imageContent
        }
        try {
          const res = await apiPostImage(sinisterId, imgBody)
          this.$emit('file:src', res)
          this.spinner = false
        } catch (e) {
          this.spinner = false

          this.throwNotification(
            this.$t('notifications.images.uploadError.title'),
            this.$t('notifications.images.uploadError.text'),
            'KO'
          )
          this.resetInputValue()

          // Send sentry custom event
          const scope = new Sentry.Scope()
          scope.setTag('section', 'file PostImages')
          scope.setContext({
            postImage: imgBody
          })
          Sentry.captureException(
            new Error('Error in post image inside fileinput'),
            () => scope
          )
        }
      }
    },
    handleChangeInput(e) {
      this.inputName = e.target.name
      const file = e.target.files[0]
      const fileSize = e.target.files[0].size

      const fileExtension = e.target.files[0].type
      const maxValueFilesize = 14000000
      const acceptedFileExtensions = 'image/jpg , image/jpeg , image/png'
      const fileSizeValidation = fileSize >= maxValueFilesize
      const isAcceptedFileExtension = acceptedFileExtensions.includes(
        fileExtension
      )

      if (fileSizeValidation || !isAcceptedFileExtension) {
        const emptyRes = new Object()
        this.$emit('file:src', emptyRes)
        this.resetInputValue()

        // Send sentry custom event
        const scope = new Sentry.Scope()
        scope.setTag('section', 'file Validation Img')
        scope.setContext({
          validationImage: file
        })
        scope.setTag({
          view: 'file.js'
        })
        Sentry.captureException(
          new Error('Error in validation image'),
          () => scope
        )

        this.throwNotification(
          this.$t('notifications.images.inputImgError.title'),
          this.$t('notifications.images.inputImgError.text'),
          'KO'
        )
      } else {
        if (fileSize >= 6000000) {
          this.compressImage(file)
        } else {
          this.postImage(file)
          this.errorInput = false
        }
      }
    },

    compressImage(file) {
      const success = function(result) {
        this.postImage(result)
        this.errorInput = false
      }

      new Compressor(file, {
        quality: 0.8,

        // The compression process is asynchronous,
        // which means you have to access the `result` in the `success` hook function.
        success: success.bind(this),
        error(e) {
          this.spinner = false
          this.throwNotification(
            this.$t('notifications.images.uploadError.title'),
            this.$t('notifications.images.uploadError.text'),
            'KO'
          )
          this.resetInputValue()
          // Send sentry custom event
          const scope = new Sentry.Scope()
          scope.setTag('section', 'file compressImage')
          scope.setContext({
            compressImage: file
          })
          Sentry.captureException(
            new Error('Error in compressor img'),
            () => scope
          )
        }
      })
    },

    resetInputValue() {
      this.$el.querySelector('input.file').value = null
    }
  },
  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterId: 'sinisterId'
    })
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.fileName = newVal.name
      }
    }
  }
}
